import React from 'react';
import { ArchiveIcon, FlagIcon, FolderKanbanIcon, MapIcon, SearchCheckIcon, ActivityIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const steps = [{
  Icon: MapIcon,
  title: 'Map',
  text: 'Know where the case is.'
}, {
  Icon: FolderKanbanIcon,
  title: 'Organize',
  text: 'Put the relevant information in one place.'
}, {
  Icon: ActivityIcon,
  title: 'Track',
  text: 'Follow the case through each stage.'
}, {
  Icon: SearchCheckIcon,
  title: 'Review',
  text: 'Create structured review points.'
}, {
  Icon: ArchiveIcon,
  title: 'Document',
  text: 'Keep the case history organized.'
}, {
  Icon: FlagIcon,
  title: 'Close',
  text: 'Finish with a complete case summary.'
}];
export function Philosophy() {
  return <section className="w-full bg-white py-14 md:py-20" aria-labelledby="philosophy-title" data-id="element-223" data-mp="2xpwupc1difnu">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-224" data-mp="3cmxach6aik5y">
        <div className="mx-auto max-w-3xl text-center" data-id="element-225" data-mp="37nuhdv3l44ec">
          <p className="font-display text-[12px] font-bold uppercase tracking-[0.2em] text-navy-800/50" data-id="element-226" data-mp="37l7yx0f5o4hc">
            This is not another aligner ebook…
          </p>
          <h2 id="philosophy-title" className="mt-2 font-display text-[24px] font-black uppercase leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-227" data-mp="gm5qphlkxyxy">
            It’s your visual command center for the entire case.
          </h2>
          <p className="mt-4 text-[15px] leading-relaxed text-navy-800/80 sm:text-base" data-id="element-228" data-mp="ul5jn1g4kzzx">
            Instead of giving you another massive document to read, ALIGNER CASE COMMANDER™ turns your
            workflow into a visual system.
          </p>
        </div>

        <ol className="mt-8 grid gap-3 sm:grid-cols-2 md:mt-12 md:grid-cols-3 md:gap-4" data-id="element-229" data-mp="14ctdf905mt4k">
          {steps.map(({
          Icon,
          title,
          text
        }, i) => <li key={title} className="flex flex-col rounded-2xl border border-navy-900/10 bg-mist px-5 py-5" data-id="element-230" data-mp="1dbwuy8job0gy" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-231" data-mp="1i8dm7bm65uy9">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy-950" data-id="element-232" data-mp="3eeo1k366972f">
                  <Icon className="h-5 w-5 text-brand-400" aria-hidden="true" data-id="element-233" data-mp="39fkw4hma4ytx" />
                </span>
                <span className="font-display text-[11px] font-black uppercase tracking-[0.2em] text-navy-800/40" data-id="element-234" data-mp="3o4haewexj82z">
                  Step {i + 1}
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-black uppercase tracking-wide text-navy-950" data-id="element-235" data-mp="xygr9nku7ff">
                {title}
              </h3>
              <p className="mt-1.5 text-[14px] leading-snug text-navy-800/75" data-id="element-236" data-mp="3t4lhjvty6qgj">{text}</p>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl bg-brand-600 px-5 py-7 text-center sm:px-8" data-id="element-237" data-mp="5y2p2cebzvuk">
          <p className="font-display text-lg font-black uppercase leading-tight text-white sm:text-2xl" data-id="element-238" data-mp="2cnr0b27dxw43">
            One case. One command center.
            <span className="block" data-id="element-239" data-mp="27r0lsjb8b8ks">One structured workflow.</span>
          </p>
          <div className="mt-6" data-id="element-240" data-mp="n8gd148lpddx">
            <CTAButton tone="gold" onDark data-id="element-241" data-mp="n9872amjv323" />
          </div>
        </div>
      </div>
    </section>;
}